import styled from 'styled-components';

export const StepBar = styled.nav<any>`
  display: flex;
  align-items: center;
  background-color: #fff;
  justify-content: center;
  border-top: 1px solid #ebebeb;
  border-bottom: ${({ active }) => (active === 3 ? '1px solid #ebebeb' : '0')};
  padding-top: 16px;
  padding-bottom: 12px;
  @media screen and (max-width: 768px) {
    height: 88px;
    border-top: none;
    padding: 0;
    margin-bottom: ${({ active }) => (active === 3 ? '0' : '16px')};
  }

  input[type='radio'] {
    width: 24px;
    height: 24px;
    margin: 0;
    z-index: 1;
  }

  input[type='radio']:checked {
    accent-color: #e60000;
  }

  .completed {
    background-color: #e60000;
    width: 18px;
    height: 18px;
    border-radius: 50%;
  }

  .not-active {
    background-color: #cccccc;
    width: 18px;
    height: 18px;
    border-radius: 50%;
  }
`;

export const StatusBox = styled.div<any>`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 120px;
  margin-right: 24px;
  margin-left: 24px;
  cursor: ${(props) =>
    props.completed || props.activeNo ? 'pointer' : 'default'};

  @media screen and (max-width: 480px) {
    width: 78px;
    margin-right: 16px;
    margin-left: 16px;
  }
  .input-box {
    display: flex;
    align-items: center;
    position: relative;
  }
  .border-right {
    background-color: ${(props) => (props.completed ? '#e60000' : '#cccccc')};
    position: absolute;
    height: 1px;
    width: 95px;
    left: 0;
  }
  .border-left {
    background-color: ${(props) =>
      props.activeNo || props.completed ? '#e60000' : '#cccccc'};
    position: absolute;
    height: 1px;
    width: 95px;
    right: 0;
  }
}
`;

export const Status = styled.div<any>`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: ${(props) => (props.completed ? '#e60000' : '#cccccc')};
  &:hover {
    background: ${(props) => (props.completed ? '#af2c2c' : '#cccccc')};
    z-index: 1;
  }
`;

export const Text = styled.div<any>`
  margin: 2px 0 0;
  font-size: 16px;
  line-height: 1.33;
  text-align: center;
  color: ${(props) => (props.activeNo || props.normal ? '#333' : '#666')};
  font-weight: ${(props) => (props.activeNo ? 'bold' : 'normal')};
  @media screen and (max-width: 480px) {
    font-size: 16px;
  }
  &:hover{
    color: ${(props) => (props.completed ? '#335' : '#666')};
    font-weight: ${(props) => (props.completed ? 'bold' : 'normal')};
  }
}
`;
